/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { LS_LIMIT_ORDERS_KEY } from './Table';
import { compareNumericString } from '../../../helpers/tableSort';

interface ITableWidths {
  src: number;
  dest: number;
  exchange: number;
  condition: number;
  side: number;
  tradesCount: number;
  status: number;
  actions: number;
  extender: number;
  createdAt: number;
}

// constants
const tableWidthsDefaultState: ITableWidths = {
  src: 180,
  dest: 180,
  exchange: 120,
  condition: 220,
  side: 110,
  tradesCount: 110,
  status: 150,
  actions: 120,
  extender: 20,
  createdAt: 176,
};

interface IUseTableDataProps {
  orders: any;
}

const useTableData = ({ orders }: IUseTableDataProps) => {
  const tableWidthsLC = localStorage.getItem(LS_LIMIT_ORDERS_KEY);

  const [tableColumnsWidth] = useState(
    tableWidthsLC ? JSON.parse(tableWidthsLC) : tableWidthsDefaultState
  );

  // table memoized required fields
  const data = React.useMemo(() => orders, [orders]);
  const columns = React.useMemo(
    () => [
      {
        id: 'extender',
        Header: '',
        accessor: 'extender',
        disableSortBy: true,
        width:
          tableColumnsWidth['extender'] || tableWidthsDefaultState['extender'],
      },
      {
        id: 'createdAt',
        Header: 'Date',
        accessor: 'created_at',
        width:
          tableColumnsWidth['createdAt'] ||
          tableWidthsDefaultState['createdAt'],
        sortType: compareNumericString(),
      },
      {
        id: 'src',
        Header: 'Send',
        accessor: 'amount_in',
        width: tableColumnsWidth['src'] || tableWidthsDefaultState['src'],
        sortType: compareNumericString(),
      },
      {
        id: 'dest',
        Header: 'Receive',
        accessor: 'amount_out',
        width: tableColumnsWidth['dest'] || tableWidthsDefaultState['dest'],
        sortType: compareNumericString(),
      },
      {
        id: 'exchange',
        Header: 'Exchange',
        accessor: 'exchange',
        width:
          tableColumnsWidth['exchange'] || tableWidthsDefaultState['exchange'],
      },
      {
        id: 'condition',
        Header: 'Price',
        accessor: 'price',
        width:
          tableColumnsWidth['condition'] ||
          tableWidthsDefaultState['condition'],
        sortType: compareNumericString('price_usd'),
      },
      {
        id: 'side',
        Header: 'Side',
        accessor: 'side',
        disableSortBy: true,
        width: tableColumnsWidth['side'] || tableWidthsDefaultState['side'],
      },
      {
        id: 'trades',
        Header: 'Trades',
        accessor: 'executed_trades_count',
        width:
          tableColumnsWidth['tradesCount'] ||
          tableWidthsDefaultState['tradesCount'],
        sortType: compareNumericString(),
      },
      {
        id: 'status',
        Header: 'Status',
        accessor: 'status',
        width: tableColumnsWidth['status'] || tableWidthsDefaultState['status'],
      },
      {
        id: 'actions',
        Header: 'Actions',
        accessor: 'actions',
        disableSortBy: true,
        width:
          tableColumnsWidth['actions'] || tableWidthsDefaultState['actions'],
      },
    ],
    []
  );

  const subColumns = React.useMemo(
    () => [
      {
        header: 'Updated At',
        accessor: 'updated_at',
      },
      {
        header: 'Send',
        accessor: 'amount_in',
      },
      {
        header: 'Receive',
        accessor: 'amount_out',
      },
      {
        header: 'Gas price',
        accessor: 'gas_price',
      },
      {
        header: 'Gas amount',
        accessor: 'gas_value',
      },
      {
        header: 'Status',
        accessor: 'status',
      },
      {
        header: 'Tx Hash',
        accessor: 'execution_tx',
      },
    ],
    []
  );

  return { columns, data, tableColumnsWidth, subColumns };
};

export { useTableData };
